import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import { getSimilarTickets } from '../services/api';
import { Pill, STATUS_COLORS } from './NotionUI';

/**
 * Ticket già visti con un problema simile a quello che si sta scrivendo (o a quello aperto): aiuta a trovare
 * una soluzione già data. Cerca da solo mentre il testo cambia (con una breve pausa) e non mostra nulla se non trova niente.
 */
function SimilarTickets({ text, excludeId, from, title }) {
  const { t } = useLanguage();
  const [items, setItems] = useState([]);
  const trimmed = (text || '').trim();

  useEffect(() => {
    if (trimmed.length < 4) {
      setItems([]);
      return undefined;
    }
    let cancelled = false;
    const timer = setTimeout(() => {
      getSimilarTickets(trimmed, excludeId)
        .then((res) => {
          if (!cancelled) setItems(res.tickets || []);
        })
        .catch(() => {
          if (!cancelled) setItems([]);
        });
    }, 600);
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [trimmed, excludeId]);

  if (items.length === 0) return null;

  return (
    <section className="sim-box">
      <h4 className="sim-title">{title || t('tickets.similarTitle')}</h4>
      <ul className="sim-list">
        {items.map((it) => (
          <li key={it.id}>
            <Link to={`/tickets/${it.id}`} state={{ from }} className="sim-item" target={from === 'new' ? '_blank' : undefined} rel="noreferrer">
              <span className="sim-id">#{it.id}</span>
              <span className="sim-subject">{it.subject}</span>
              <Pill dot color={STATUS_COLORS[it.status]}>{t(`tickets.status_${it.status}`)}</Pill>
            </Link>
          </li>
        ))}
      </ul>
      <p className="tp-hint">{t('tickets.similarHint')}</p>
    </section>
  );
}

export default SimilarTickets;
